<div [formGroup]="orderForm">
  <!-- <mat-card> -->

  <div class="row">

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Fator conversão Imagem mm->pixels" formControlName="mmToPixelsFactor" type="number">
      </mat-form-field>
    </div>

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Rotação (Graus)" formControlName="displayAngle" type="number">
      </mat-form-field>
    </div>

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Margem superior" formControlName="topMargin" type="number">
      </mat-form-field>
    </div>

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Margem esquerda" formControlName="leftMargin" type="number">
      </mat-form-field>
    </div>

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="rowDist" formControlName="rowDist" type="number">
      </mat-form-field>
    </div>

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="rectHeight" formControlName="rectHeight" type="number">
      </mat-form-field>
    </div>

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="colDist" formControlName="colDist" type="number">
      </mat-form-field>
    </div>

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="rectWidth" formControlName="rectWidth" type="number">
      </mat-form-field>
    </div>

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Ajuste lateral para impressão (mm)" formControlName="adjustLeft" type="number">
      </mat-form-field>
    </div>

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Ajuste superior para impressão (mm)" formControlName="adjustTop" type="number">
      </mat-form-field>
    </div>

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Altura do Cartão (mm)" formControlName="paperPrintHeight" type="number">
      </mat-form-field>
      <span>Esse valor é utilizado na impressão em folhas</span>
    </div>

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Largura do Cartão (mm)" formControlName="paperPrintWidth" type="number">
      </mat-form-field>
    </div>
    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Colunas de cartões" formControlName="cardsCols" type="number">
      </mat-form-field>
      <span>Esse valor é utilizado na impressão em folhas</span>
    </div>

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Linhas de cartões" formControlName="cardsRows" type="number">
      </mat-form-field>
      <span>Esse valor é utilizado na impressão em folhas</span>
    </div>
  </div>

  <br>
  <span>Dados do texto</span>
  <mat-divider></mat-divider>
  <br>
  <div class="row">

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Margem superior do texto (mm)" formControlName="textMarginTop" type="number">
      </mat-form-field>
    </div>
    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Margem lateral do texto (mm)" formControlName="textMarginLeft" type="number">
      </mat-form-field>
    </div>
    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Larguma máxima do texto (mm)" formControlName="textRectWidth" type="number">
      </mat-form-field>
    </div>
    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Altura máxima do texto (mm)" formControlName="textRectHeight" type="number">
      </mat-form-field>
    </div>
    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Altura da fonte (mm)" formControlName="textFontHeigth" type="number">
      </mat-form-field>
    </div>
    <div class="col-md-3 full-width">
   
        <mat-checkbox  formControlName="textFontBold" >Fonte em negrito</mat-checkbox>
  
    </div>

    <div class="col-md-3 full-width">
      <mat-form-field>
        <input matInput placeholder="Escala de impressão" formControlName="printScaleFactor" type="number">
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <button (click)="addParameter()">Adicionar Bloco</button>
    </div>
  </div>
  <div class="row">
    <div formArrayName="blockPositions" *ngFor="let item of _blockPositions.controls; let i = index;">
      <div [formGroupName]="i">

        <div class="col-md-1">
          <mat-form-field>
            <input matInput formControlName="x" placeholder="x" type="number">
          </mat-form-field>
        </div>
        <div class="col-md-1">
          <mat-form-field>
            <input matInput formControlName="y" placeholder="y" type="number">
          </mat-form-field>
        </div>
        <div class="col-md-1">
          <mat-form-field>
            <input matInput formControlName="Col" placeholder="Col" type="number">
          </mat-form-field>
        </div>
        <div class="col-md-1">
          <mat-form-field>
            <input matInput formControlName="Row" placeholder="Row" type="number">
          </mat-form-field>
        </div>
        <div class="col-md-1">
          <mat-form-field>
            <input matInput formControlName="ColsLength" placeholder="ColsLength" type="number">
          </mat-form-field>
        </div>
        <div class="col-md-1">
          <mat-form-field>
            <input matInput formControlName="RowsLength" placeholder="RowsLength" type="number">
          </mat-form-field>
        </div>
        <div class="col-md-1">
          <button mat-raised-button color="primary" (click)="removeBlock(i)">Remover</button>
        </div>

      </div>
    </div>
  </div>
  <!-- </mat-card> -->

</div>